(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yevanjel-button-motion"] && !Shopify.designMode) return;
  try {
    (() => {
    if (document.documentElement.hasAttribute('data-yv-touch-ready')) return;
    document.documentElement.setAttribute('data-yv-touch-ready', '');
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    const selector = 'button,input[type="submit"],input[type="button"],input[type="reset"],[role="button"],summary,a.theme-cta,a.theme-button,a.button,a.btn,[data-yv-magnetic],nav a[href],.yv-sticky__button,.yv-signup__button,[data-yv-touch]';
    const excluded = '[data-yv-motion="off"],shopify-accelerated-checkout,shopify-accelerated-checkout-cart,.shopify-payment-button,#admin-bar-iframe,#PBarNextFrame';
    const running = new Map();
    const pointers = new Map();
    const released = new WeakMap();
    const echoes = new Set();
    let keyboard = null;

    function control(target) {
      if (!(target instanceof Element)) return null;
      let el = target.closest(selector);
      if (!el) {
        const label = target.closest('label');
        const input = label && label.control;
        if (input && /^(radio|checkbox)$/.test(input.type) && !input.disabled) el = label;
      }
      if (!el || el.closest(excluded) || el.closest('[inert],[aria-disabled="true"],[aria-busy="true"]') || el.matches(':disabled') || el.getAttribute('aria-disabled') === 'true') return null;
      if (el instanceof HTMLLabelElement && (!el.control || el.control.disabled)) return null;
      return el;
    }

    function stop(el) {
      const state = running.get(el);
      if (!state) return;
      clearTimeout(state.timer);
      state.animation.onfinish = null;
      state.animation.cancel();
      running.delete(el);
    }

    function animate(el, frames, options, finish) {
      stop(el);
      if (media.matches || !el.isConnected || typeof el.animate !== 'function') return;
      const animation = el.animate(frames, options);
      const state = { animation, timer: 0 };
      running.set(el, state);
      animation.onfinish = () => {
        if (finish && running.get(el) === state) stop(el);
      };
      if (!finish) state.timer = setTimeout(() => release(el, false), 4000);
    }

    function press(el) {
      if (media.matches || !el) return;
      el.setAttribute('data-yv-touch', '');
      const style = getComputedStyle(el);
      const current = style.scale === 'none' ? '1' : style.scale;
      const rect = el.getBoundingClientRect();
      const amount = rect.width < 90 && rect.height < 90 ? .90 : rect.width > 420 ? .984 : .95;
      animate(el, [{ scale: current }, { scale: String(amount) }], { duration: 90, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'forwards' }, false);
    }

    function echo(el) {
      if (media.matches || !el.isConnected || el.matches(':disabled') || el.closest('[aria-disabled="true"],[aria-busy="true"]') || echoes.size >= 4) return;
      const rect = el.getBoundingClientRect();
      if (rect.width < 2 || rect.height < 2 || rect.width > 640 || rect.height > 160 || rect.bottom < 0 || rect.top > innerHeight) return;
      const style = getComputedStyle(el);
      const mark = document.createElement('span');
      mark.className = 'yv-touch-echo';
      mark.setAttribute('aria-hidden', 'true');
      Object.assign(mark.style, { left: `${rect.left}px`, top: `${rect.top}px`, width: `${rect.width}px`, height: `${rect.height}px`, borderRadius: style.borderRadius, color: style.color });
      document.body.appendChild(mark);
      echoes.add(mark);
      const animation = mark.animate([{ opacity: .26, transform: 'scale(1)' }, { opacity: 0, transform: 'scale(1.10,1.22)' }], { duration: 330, easing: 'cubic-bezier(.16,1,.3,1)' });
      const remove = () => { mark.remove(); echoes.delete(mark); };
      animation.onfinish = remove;
      animation.oncancel = remove;
      setTimeout(remove, 500);
    }

    function release(el, bounce = true) {
      if (!el) return;
      const style = el.isConnected ? getComputedStyle(el) : null;
      const current = style && style.scale !== 'none' ? style.scale : '1';
      released.set(el, performance.now());
      if (!bounce || media.matches || !el.isConnected) { stop(el); return; }
      const wide = el.getBoundingClientRect().width > 420;
      animate(el, [{ scale: current, offset: 0 }, { scale: wide ? '1.009' : '1.035', offset: .42 }, { scale: '.997', offset: .74 }, { scale: '1', offset: 1 }], { duration: 340, easing: 'cubic-bezier(.2,.7,.3,1)' }, true);
      echo(el);
    }

    function reset() {
      pointers.clear();
      keyboard = null;
      for (const el of Array.from(running.keys())) stop(el);
      for (const mark of echoes) mark.remove();
      echoes.clear();
    }

    document.addEventListener('pointerdown', event => {
      if (!event.isPrimary || event.button !== 0 || media.matches) return;
      const el = control(event.target);
      if (!el) return;
      pointers.set(event.pointerId, { el, x: event.clientX, y: event.clientY });
      press(el);
    }, { capture: true, passive: true });

    document.addEventListener('pointermove', event => {
      const state = pointers.get(event.pointerId);
      if (state && Math.hypot(event.clientX - state.x, event.clientY - state.y) > 12) {
        pointers.delete(event.pointerId);
        release(state.el, false);
      }
    }, { capture: true, passive: true });

    document.addEventListener('pointerup', event => {
      const state = pointers.get(event.pointerId);
      if (!state) return;
      pointers.delete(event.pointerId);
      const hit = document.elementFromPoint(event.clientX, event.clientY);
      release(state.el, !!hit && (hit === state.el || state.el.contains(hit)) && !!control(state.el));
    }, { capture: true, passive: true });

    document.addEventListener('pointercancel', event => {
      const state = pointers.get(event.pointerId);
      pointers.delete(event.pointerId);
      if (state) release(state.el, false);
    }, { capture: true, passive: true });

    document.addEventListener('keydown', event => {
      if (event.repeat || (event.key !== 'Enter' && event.key !== ' ')) return;
      const el = control(event.target);
      if (!el || (event.key === ' ' && el.matches('a[href]:not([role="button"])'))) return;
      keyboard = el;
      press(el);
    }, true);

    document.addEventListener('keyup', event => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const el = keyboard;
      keyboard = null;
      release(el, !!control(el));
    }, true);

    document.addEventListener('focusout', () => {
      if (keyboard) { release(keyboard, false); keyboard = null; }
    }, true);

    document.addEventListener('click', event => {
      const el = control(event.target);
      if (!el || media.matches || running.has(el) || performance.now() - (released.get(el) || -1000) < 450) return;
      el.setAttribute('data-yv-touch', '');
      animate(el, [{ scale: '1' }, { scale: '.95', offset: .2 }, { scale: '1.025', offset: .62 }, { scale: '1' }], { duration: 340, easing: 'ease-out' }, true);
      echo(el);
    }, true);

    window.addEventListener('blur', reset);
    window.addEventListener('pagehide', reset);
    document.addEventListener('visibilitychange', () => { if (document.hidden) reset(); });
    document.addEventListener('scroll', () => { if (pointers.size || echoes.size) reset(); }, { capture: true, passive: true });
    media.addEventListener('change', reset);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yevanjel-early-access"] && !Shopify.designMode) return;
  try {
    (() => {
    if (document.documentElement.hasAttribute('data-yv-access-ready')) return;
    document.documentElement.setAttribute('data-yv-access-ready', '');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const root = document.documentElement;
    const isAccess = hash => hash === '#early-access' || /^#shopify-section-[^#]*__yevanjel_signup_/.test(hash);
    const target = () => document.getElementById('early-access');
    function linkURL(link) {
      if (!link || !link.hasAttribute('href')) return null;
      try {
        const url = new URL(link.getAttribute('href'), location.href);
        return url.origin === location.origin && isAccess(url.hash) ? url : null;
      } catch { return null; }
    }
    function normalizeLink(link) {
      const url = linkURL(link);
      if (!url) return false;
      const home = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      link.setAttribute('href', target() ? '#early-access' : `${home}${url.search}#early-access`);
      return true;
    }
    function normalizeLinks() {
      document.querySelectorAll('a[href*="#early-access"],a[href*="__yevanjel_signup_"]').forEach(normalizeLink);
    }
    function reveal(behavior, focus = false) {
      const el = target();
      if (!el) return;
      if (focus) el.focus({ preventScroll: true });
      el.scrollIntoView({ behavior: reduced.matches ? 'instant' : behavior, block: 'start' });
    }
    normalizeLinks();
    document.addEventListener('shopify:section:load', normalizeLinks);
    document.addEventListener('click', event => {
      const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
      if (!normalizeLink(link) || !target() || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
      event.preventDefault();
      if (location.hash !== '#early-access') history.pushState(null, '', `${location.pathname}${location.search}#early-access`);
      reveal('smooth', event.detail === 0);
    });
    function initialAnchor() {
      if (!isAccess(location.hash) || !target()) return;
      if (location.hash !== '#early-access') history.replaceState(null, '', `${location.pathname}${location.search}#early-access`);
      if (root.classList.contains('yv-intro-active') && !root.classList.contains('yv-intro-done')) {
        const observer = new MutationObserver(() => {
          if (!root.classList.contains('yv-intro-done') && root.classList.contains('yv-intro-active')) return;
          observer.disconnect();
          if (isAccess(location.hash)) requestAnimationFrame(() => reveal('instant'));
        });
        observer.observe(root, { attributes: true, attributeFilter: ['class'] });
        setTimeout(() => observer.disconnect(), 6000);
      } else {
        requestAnimationFrame(() => reveal('instant'));
      }
    }
    if (document.readyState === 'complete') initialAnchor();
    else window.addEventListener('load', initialAnchor, { once: true });
    window.addEventListener('hashchange', () => { if (isAccess(location.hash)) reveal('instant'); });
  })();
  } catch(e) { console.error(e); }
})();

})();
